import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/covid-virus.png'


const _withScopeId = n => (_pushScopeId("data-v-0efcdd92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hd-mod-content-splash hd-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hd-mod-content-splash__image" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_3 = { class: "hd-mod-content-splash__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lyra_asset = _resolveComponent("lyra-asset")!
  const _component_base_image_svg = _resolveComponent("base-image-svg")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_lyra_asset, {
        class: "hd-mod-content-splash__title",
        "asset-key": "mod-splash-title"
      }),
      _createVNode(_component_lyra_asset, {
        class: "hd-mod-content-splash__copy",
        "asset-key": "mod-splash-copy"
      }),
      _createElementVNode("div", {
        class: "hd-mod-content-splash__cta",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchScreen('timeline')))
      }, [
        _createVNode(_component_base_image_svg, {
          class: "hd-mod-content-splash__cta-icon",
          source: require('!html-loader!../assets/icons/down-arrow.svg')
        }, null, 8, ["source"]),
        _createVNode(_component_lyra_asset, {
          class: "hd-mod-content-splash__cta-text",
          "asset-key": "mod-misc-start"
        })
      ])
    ])
  ]))
}